import { CorpusApprovalEnum, PaymentStatusEnum, PayMode } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { ExpensesCategory } from "../../expenses-category/expenses-category.entity";
import { ExpensesSubCategory } from "../../expenses-sub-category/expenses-sub-category.entity";



@Entity('expenses')

export class Expenses {

    @PrimaryGeneratedColumn("increment",{name:'expenses_id'})
    expensesId:number;

    @Column("char",{
        nullable:false,
        length:50,
        name:"expenses_against"
        })
    // @Index({ unique: true })
    expensesAgainst:string;
  
    @Column("int",{
        nullable:false,
        name:"expenses_category_id"
        })
    // @Index({ unique: true })
    expensesCategoryId:number;

    @Column("char",{
        nullable:false,
        length:50,
        name:"payment_mode"
        })
    // @Index({ unique: true })
    paymentMode:string;

    @Column("char",{
        nullable:false,
        length:50,
        name:"refrence_no"
        })
    // @Index({ unique: true })
    refrenceNo:string;

    @Column("char",{
        nullable:false,
        name:"paid_to",
        length:20
        })
    // @Index({ unique: true })
    paidToEmployeeOrVendor:string;

    @Column("char",{
        nullable:false,
        name:"employee_name",
        length:20
        })
    // @Index({ unique: true })
    employeeName:string;

    @Column("enum",{
        nullable:false,
        name:"payment_status",
        enum:PaymentStatusEnum
        })
    // @Index({ unique: true })
    paymentStatus:PaymentStatusEnum;

    @Column("int",{
        nullable:false,
        name:"amount"
        })
    // @Index({ unique: true })
    amount:number;

    @Column("enum",{
        nullable:false,
        name:"corpus_approval",
        enum:CorpusApprovalEnum
        })
    // @Index({ unique: true })
    corpusApproval:CorpusApprovalEnum;

    @Column("char",{
        nullable:false,
        length:50,
        name:"approved_by"
        })
    // @Index({ unique: true })
    approvedBy:string;

    @Column("char",{
        nullable:false,
        length:50,
        name:"remarks"
        })
    // @Index({ unique: true })
    remarks:string;
  
    @Column("boolean",{
      nullable:false,
      default:true,
      name:"is_active"
      })
    isActive:boolean;
    
    @CreateDateColumn({
      name: "created_at",
      type:"datetime"
    })
    createdAt: Date;
  
    @Column("varchar", {
        nullable: false,
        default:1,
        name: "created_user"
    })
    createdUser: string | null;
  
  
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;
  
    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;
  
  
    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
  
  
    @ManyToOne(type=>ExpensesCategory, expensesCategory=>expensesCategory.expensesInfo,{  nullable:false, })
    @JoinColumn({ name:"expenses_category_id"})
    expensesCategoryInfo: ExpensesCategory;
}